// The signed clientToken carries the apiKey that authorizes tokenization and
// card-create. If it's absent or unparseable we can't derive an apiKey, so the
// frame fails fast with a configurationError instead of proceeding with an
// unauthorized (or mock) token. Mirrors Orion's add-card element.
export function resolveConfigError(clientToken: string, apiKey: string): string | null {
  if (!clientToken) {
    return "Missing clientToken";
  }
  if (!apiKey) {
    return "Invalid clientToken";
  }
  return null;
}
